<template>
  <div
    class="grow flex flex-col items-center justify-center absolute left-1/2 -translate-x-1/2 w-full top-16 max-w-[calc(100vw-16px)] sm:w-[calc(100vw-96px)] md:w-[calc(100vw-144px)] xl:max-w-[1074px] mx-auto"
  >
    <div class="py-4 pt-12 w-full max-w-full mb-auto grid overflow-hidden">
      <ProgressBar :value="progress" :show-value="false" style="height: 5px" />
    </div>
    <TipsWrapper
      class="mt-4 opacity-0 max-w-full animate-[fade-in_0.5s_0.2s_forwards] mb-auto"
    />
  </div>
</template>

<script setup lang="ts">
import TipsWrapper from "../tips/TipsWrapper.vue";
import ProgressBar from "@/volt/ProgressBar.vue";
defineProps<{
  description?: string;
}>();
usePauseScroll();

const { progress } = useFakeProgress({
  maxValue: 99,
  increments: 25,
  minValue: 20,
  interval: 300,
});
</script>
<style scoped>
.pulse {
  animation: pulse 2.8s linear infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.04);
  }
  100% {
    transform: scale(1);
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
